/**
 * Generated file, do not edit directly!
 */

/** Animations enhance user experience by assisting users in focusing their attention, conveying spatial relationships, and expressing our brand's tone. */

/** Use for opening or expanding elements. */
const Open = {
  Duration: {
    /** Css custom property: --dt-animations-open-duration-fast. Default value: 170ms. */
    Fast: 'var(--dt-animations-open-duration-fast, 170ms)',
    /** Css custom property: --dt-animations-open-duration-base. Default value: 250ms. */
    Base: 'var(--dt-animations-open-duration-base, 250ms)',
    /** Css custom property: --dt-animations-open-duration-slow. Default value: 400ms. */
    Slow: 'var(--dt-animations-open-duration-slow, 400ms)',
  },
  /** Css custom property: --dt-animations-open-easing. Default value: cubic-bezier(0, 0, 0.2, 1). */
  Easing: 'var(--dt-animations-open-easing, cubic-bezier(0, 0, 0.2, 1))',
};
/** Use for closing or collapsing elements. */
const Close = {
  Duration: {
    /** Css custom property: --dt-animations-close-duration-fast. Default value: 0ms. */
    Fast: 'var(--dt-animations-close-duration-fast, 0ms)',
    /** Css custom property: --dt-animations-close-duration-base. Default value: 170ms. */
    Base: 'var(--dt-animations-close-duration-base, 170ms)',
    /** Css custom property: --dt-animations-close-duration-slow. Default value: 250ms. */
    Slow: 'var(--dt-animations-close-duration-slow, 250ms)',
  },
  /** Css custom property: --dt-animations-close-easing. Default value: cubic-bezier(0.5, 0, 1, 1). */
  Easing: 'var(--dt-animations-close-easing, cubic-bezier(0.5, 0, 1, 1))',
};
/** Use for sliding elements into view. */
const SlideIn = {
  Duration: {
    /** Css custom property: --dt-animations-slide-in-duration-fast. Default value: 200ms. */
    Fast: 'var(--dt-animations-slide-in-duration-fast, 200ms)',
    /** Css custom property: --dt-animations-slide-in-duration-base. Default value: 300ms. */
    Base: 'var(--dt-animations-slide-in-duration-base, 300ms)',
    /** Css custom property: --dt-animations-slide-in-duration-slow. Default value: 400ms. */
    Slow: 'var(--dt-animations-slide-in-duration-slow, 400ms)',
  },
  /** Css custom property: --dt-animations-slide-in-easing. Default value: cubic-bezier(0, 0, 0.2, 1). */
  Easing: 'var(--dt-animations-slide-in-easing, cubic-bezier(0, 0, 0.2, 1))',
};
/** Use for sliding elements out of view. */
const SlideOut = {
  Duration: {
    /** Css custom property: --dt-animations-slide-out-duration-fast. Default value: 150ms. */
    Fast: 'var(--dt-animations-slide-out-duration-fast, 150ms)',
    /** Css custom property: --dt-animations-slide-out-duration-base. Default value: 250ms. */
    Base: 'var(--dt-animations-slide-out-duration-base, 250ms)',
    /** Css custom property: --dt-animations-slide-out-duration-slow. Default value: 350ms. */
    Slow: 'var(--dt-animations-slide-out-duration-slow, 350ms)',
  },
  /** Css custom property: --dt-animations-slide-out-easing. Default value: cubic-bezier(0.8, 0, 0.5, 1). */
  Easing: 'var(--dt-animations-slide-out-easing, cubic-bezier(0.8, 0, 0.5, 1))',
};
/** Use for fading in elements. */
const FadeIn = {
  Duration: {
    /** Css custom property: --dt-animations-fade-in-duration-fast. Default value: 150ms. */
    Fast: 'var(--dt-animations-fade-in-duration-fast, 150ms)',
    /** Css custom property: --dt-animations-fade-in-duration-base. Default value: 250ms. */
    Base: 'var(--dt-animations-fade-in-duration-base, 250ms)',
    /** Css custom property: --dt-animations-fade-in-duration-slow. Default value: 350ms. */
    Slow: 'var(--dt-animations-fade-in-duration-slow, 350ms)',
  },
  /** Css custom property: --dt-animations-fade-in-easing. Default value: cubic-bezier(0.5, 0, 1, 1). */
  Easing: 'var(--dt-animations-fade-in-easing, cubic-bezier(0.5, 0, 1, 1))',
};
/** Use for fading out elements. */
const FadeOut = {
  Duration: {
    /** Css custom property: --dt-animations-fade-out-duration-fast. Default value: 150ms. */
    Fast: 'var(--dt-animations-fade-out-duration-fast, 150ms)',
    /** Css custom property: --dt-animations-fade-out-duration-base. Default value: 250ms. */
    Base: 'var(--dt-animations-fade-out-duration-base, 250ms)',
    /** Css custom property: --dt-animations-fade-out-duration-slow. Default value: 350ms. */
    Slow: 'var(--dt-animations-fade-out-duration-slow, 350ms)',
  },
  /** Css custom property: --dt-animations-fade-out-easing. Default value: cubic-bezier(0, 0, 0.2, 1). */
  Easing: 'var(--dt-animations-fade-out-easing, cubic-bezier(0, 0, 0.2, 1))',
};
/** Use for hovering interactive elements. */
const Hover = {
  Duration: {
    /** Css custom property: --dt-animations-hover-duration-base. Default value: 150ms. */
    Base: 'var(--dt-animations-hover-duration-base, 150ms)',
  },
  /** Css custom property: --dt-animations-hover-easing. Default value: cubic-bezier(0, 0, 0.2, 1). */
  Easing: 'var(--dt-animations-hover-easing, cubic-bezier(0, 0, 0.2, 1))',
};
/** Use for progressively revealing or animating elements. */
const StaggeredMotion = {
  Duration: {
    /** Css custom property: --dt-animations-staggered-motion-duration-fast. Default value: 250ms. */
    Fast: 'var(--dt-animations-staggered-motion-duration-fast, 250ms)',
    /** Css custom property: --dt-animations-staggered-motion-duration-base. Default value: 350ms. */
    Base: 'var(--dt-animations-staggered-motion-duration-base, 350ms)',
    /** Css custom property: --dt-animations-staggered-motion-duration-slow. Default value: 400ms. */
    Slow: 'var(--dt-animations-staggered-motion-duration-slow, 400ms)',
  },
  Offset: {
    /** Css custom property: --dt-animations-staggered-motion-offset-fast. Default value: 20ms. */
    Fast: 'var(--dt-animations-staggered-motion-offset-fast, 20ms)',
    /** Css custom property: --dt-animations-staggered-motion-offset-base. Default value: 30ms. */
    Base: 'var(--dt-animations-staggered-motion-offset-base, 30ms)',
    /** Css custom property: --dt-animations-staggered-motion-offset-slow. Default value: 50ms. */
    Slow: 'var(--dt-animations-staggered-motion-offset-slow, 50ms)',
  },
  /** Css custom property: --dt-animations-staggered-motion-easing. Default value: cubic-bezier(0, 0, 0.2, 1). */
  Easing:
    'var(--dt-animations-staggered-motion-easing, cubic-bezier(0, 0, 0.2, 1))',
};
/** Use for expanding and collapsing elements such as accordions or expandables. */
const ExpandCollapse = {
  Duration: {
    /** Css custom property: --dt-animations-expand-collapse-duration-fast. Default value: 250ms. */
    Fast: 'var(--dt-animations-expand-collapse-duration-fast, 250ms)',
    /** Css custom property: --dt-animations-expand-collapse-duration-base. Default value: 400ms. */
    Base: 'var(--dt-animations-expand-collapse-duration-base, 400ms)',
    /** Css custom property: --dt-animations-expand-collapse-duration-slow. Default value: 600ms. */
    Slow: 'var(--dt-animations-expand-collapse-duration-slow, 600ms)',
  },
  /** Css custom property: --dt-animations-expand-collapse-easing. Default value: cubic-bezier(0.4, 0, 0.2, 1). */
  Easing:
    'var(--dt-animations-expand-collapse-easing, cubic-bezier(0.4, 0, 0.2, 1))',
};
/** Use for elements changing position. */
const Move = {
  Duration: {
    /** Css custom property: --dt-animations-move-duration-fast. Default value: 150ms. */
    Fast: 'var(--dt-animations-move-duration-fast, 150ms)',
    /** Css custom property: --dt-animations-move-duration-base. Default value: 400ms. */
    Base: 'var(--dt-animations-move-duration-base, 400ms)',
    /** Css custom property: --dt-animations-move-duration-slow. Default value: 600ms. */
    Slow: 'var(--dt-animations-move-duration-slow, 600ms)',
  },
  /** Css custom property: --dt-animations-move-easing. Default value: cubic-bezier(0.4, 0, 0.2, 1). */
  Easing: 'var(--dt-animations-move-easing, cubic-bezier(0.4, 0, 0.2, 1))',
};
/** Use for rescaling elements. */
const Rescale = {
  Duration: {
    /** Css custom property: --dt-animations-rescale-duration-fast. Default value: 170ms. */
    Fast: 'var(--dt-animations-rescale-duration-fast, 170ms)',
    /** Css custom property: --dt-animations-rescale-duration-base. Default value: 250ms. */
    Base: 'var(--dt-animations-rescale-duration-base, 250ms)',
    /** Css custom property: --dt-animations-rescale-duration-slow. Default value: 400ms. */
    Slow: 'var(--dt-animations-rescale-duration-slow, 400ms)',
  },
  /** Css custom property: --dt-animations-rescale-easing. Default value: cubic-bezier(0.4, 0, 0.2, 1). */
  Easing: 'var(--dt-animations-rescale-easing, cubic-bezier(0.4, 0, 0.2, 1))',
};
export default {
  Open,
  Close,
  SlideIn,
  SlideOut,
  FadeIn,
  FadeOut,
  Hover,
  StaggeredMotion,
  ExpandCollapse,
  Move,
  Rescale,
};
